import './UserAvatar.scss'
import React from 'react'
interface UserAvatarProps extends React.ComponentPropsWithoutRef<'div'> {
  onClick?: () => void
  width?: string
  height?: string
  fontSize?: string
  icon?: string
  initialLetters?: string
  useInitials?: boolean
}

export const UserAvatar: React.FC<UserAvatarProps> = ({
  onClick,
  className,
  width,
  height,
  fontSize,
  icon = 'bi bi-person',
  initialLetters = '',
  useInitials = false,
  ...rest
}) => {
  const handleOnClick = () => {
    onClick && onClick()
  }

  return (
    <div
      role={onClick ? 'button' : undefined}
      onClick={handleOnClick}
      className={`zocks__user-avatar d-flex justify-content-center align-items-center ${className ? className : ''}`}
      style={{ ...(width && { width: width }), ...(height && { height: height }) }}
      {...rest}
    >
      {useInitials && initialLetters ? <div>{initialLetters}</div> : <i className={icon} style={{ ...(fontSize && { fontSize: fontSize }) }}></i>}
    </div>
  )
}
